import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { extractError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue ${u.full_name}`);
      navigate(u.role === "admin" ? "/admin" : "/");
    } catch (e) {
      toast.error(extractError(e, "Connexion échouée"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a1e3f] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8"><Logo variant="light" size="lg" /></div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 mbk-card-shadow" data-testid="login-form">
          <h1 className="font-display text-2xl font-black text-[#0a1e3f]">Connexion</h1>
          <p className="text-sm text-gray-500 mt-1">Accédez à votre votre espace.</p>
          <div className="mt-6 space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Email</Label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest font-bold text-gray-500">Mot de passe</Label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-12" />
            </div>
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="mbk-btn-primary text-white w-full h-12 mt-6 rounded-full font-semibold">
            {loading ? "Connexion…" : "Se connecter"}
          </Button>
          <div className="text-center mt-6 text-sm text-gray-500">
            Pas de compte ? <Link to="/register" className="text-[#0a1e3f] font-bold hover:underline">Créer un compte</Link>
          </div>
        </form>
        <div className="text-center mt-4 text-white/60 text-xs">
          <Link to="/" className="hover:text-white">← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}
